import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const DeliveryModal = Loadable(lazy(() => import('./view/DeliveryModal')));

const driverRoutes = [{ path: '/delivery', element: <DeliveryModal /> }];

export default driverRoutes;
